export default "__VITE_ASSET__b027faf1__"